import {useMutation, useQueryClient} from '@tanstack/react-query'
import {GOAL_API} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useNotifyAdminGoalUpdated = (goalId: string | number, onSuccess: () => void) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: () => GOAL_API.notifyAdminGoalUpdated(`${goalId}`),
        onSuccess: () => {
            onSuccess()
            queryClient.invalidateQueries({queryKey: [QUERY_KEYS.selectedGoal]})
        }
    })
}
